export default __webpack_public_path__ + "static/media/05 Track 5.8b38d381.mp3";